import { ResolveBaseApiUrl } from "../utils/Utility";
import APIService from "./APIService";

const baseUrl = ResolveBaseApiUrl() + "Login/";
const loginAPIService = new APIService(baseUrl);

//Login
export async function ValidateLogin({ useremail, password }) {
  var url = `validatelogin?useremail=${useremail}&password=${password}`;
  return await loginAPIService.fetchData(url);
}
//OTP
export async function OTPLogin({ useremail, otp }) {
  var url = `validateotp?useremail=${useremail}&otp=${otp}`;
  return await loginAPIService.fetchData(url);
}

// Forgot Password
export async function ForgotPasswordAPI({ useremail }) {
  var url = `forgotpassword?useremail=${useremail}`;
  return await loginAPIService.fetchData(url);
}

//Reset Password
export async function ResetPasswordAPI({ newpassword, token }) {
  var url = `resetpassword?newpassword=${newpassword}&token=${encodeURIComponent(
    token
  )}`;
  return await loginAPIService.fetchData(url);
}

//Update Password
export async function UpdatePassword(useremail) {
  var url = `updatepassword?email=${useremail}`;
  return await loginAPIService.fetchData(url);
}

export async function GetRequestorCustomer(requestorid) {
  var url = `getrequestorcustomerdetail?requestorid=${requestorid}`;
  return await loginAPIService.fetchData(url);
}
